import type { AdPlacement } from './types';

/**
 * 자리별 동시 게재 상한 기본값 «정본»(HC 정리 2026-10-24) — 운영값은 app_config ads.caps.
 *   ⚠️ 가격이 든 ADS_DEFAULTS(./defaults)와 나눠 둔 까닭: 홈 캐러셀(클라이언트 컴포넌트)이 상한만 읽는다 —
 *      가격 숫자가 브라우저 번들에 실리지 않게(가격은 서버 견적에서만 공개).
 */
export const ADS_DEFAULT_CAPS: Readonly<Record<AdPlacement, number>> = { site: 1, district: 3, home: 6 };
